/**
 * Adam, ca in application/views/version-3/_partials/icons/adam.php.
 *
 * `hands`: cu labutele sprijinite pe muchie - pe bara de jos (perch) el nu
 * pluteste, se tine de ea. Nu e un al doilea desen: acelasi cap, cu sau fara
 * maini, ca in macheta (`$adamHands`).
 *
 * Marimea se scrie pe element cu `!important`, ca in macheta: `app.css` are
 * `svg { width: 100% !important }` pentru toate desenele, si un `style`
 * obisnuit pierde in fata ei. Asa ajungea capul lui la toata latimea
 * antetului din sertar si impingea insigna de mod si sageata de coborare
 * afara din panou - de-aia "nu se putea colapsa". React nu scrie `!important`
 * din obiectul `style`, deci se pune prin `setProperty`.
 */
export function Adam({ size = 24, title = '', hands = false }: { size?: number; title?: string; hands?: boolean }) {
  const fix = (el: SVGSVGElement | null) => {
    if (!el) return
    el.style.setProperty('width', `${size}px`, 'important')
    el.style.setProperty('height', `${size}px`, 'important')
  }
  return (
    <svg
      ref={fix}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className="od-adam"
      {...(title === '' ? { 'aria-hidden': true, focusable: 'false' } : { role: 'img' })}
    >
      {title !== '' && <title>{title}</title>}
      <rect x="1" y="25" width="9" height="17" rx="4.5" fill="#C87A32" />
      <rect x="54" y="25" width="9" height="17" rx="4.5" fill="#C87A32" />
      <rect x="7" y="5" width="50" height="54" rx="19" fill="#E09348" />
      <path d="M7 44a19 19 0 0 0 19 15h12a19 19 0 0 0 19-15z" fill="#CF8339" />
      <rect x="14" y="16" width="36" height="31" rx="12" fill="#402A1F" />
      <circle cx="25" cy="29" r="4.6" fill="#F5E9DA" />
      <circle cx="39" cy="29" r="4.6" fill="#F5E9DA" />
      <path
        d="M27 38.5c1.6 1.9 3.1 2.8 5 2.8s3.4-.9 5-2.8"
        fill="none"
        stroke="#F5E9DA"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      {hands && (
        <>
          {/* Labutele, desenate ultimele ca sa cada peste barbie: el se tine de muchie. */}
          <g fill="#C87A32">
            <rect x="4" y="52" width="17" height="11" rx="5.5" />
            <rect x="43" y="52" width="17" height="11" rx="5.5" />
          </g>
          <g stroke="#A96326" strokeWidth="1.4" strokeLinecap="round">
            <path d="M9 55.5v4M14 55.5v4M48 55.5v4M53 55.5v4" />
          </g>
        </>
      )}
    </svg>
  )
}
